import { settingsService } from "@services/settings.service";

export const useRegion = () => ({
  currentRegionCode: (): string => settingsService.options.region.code,
  defaultRegionCode: (): string => "DE",
});
